import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Vuelve al inicio de la página en cada cambio de ruta.
    window.scrollTo(0, 0);
  }, [pathname]);

  // Este componente no renderiza nada en la UI.
  return null;
};

export default ScrollToTop;
